// Module
var code = `<div class="date-picker-drop-down" style="position:absolute;left:{{.left || 0}}px;top:{{.top || 0}}px;{{^.visible}}visibility:hidden;{{/}}">
    <terceraDatePickerCalendarComponent name="dtpicker" />
</div>
`;
// Exports
export default code;